import React, { useEffect, useState } from "react";
import * as echarts from "echarts";

export default function Report() {
  const [smallViewWidth, setisSmallviewWidth] = useState(false);
  useEffect(() => {
    window.innerWidth < 1192
      ? setisSmallviewWidth(true)
      : setisSmallviewWidth(false);

    window.addEventListener("resize", () => {
      window.innerWidth < 1192
        ? setisSmallviewWidth(true)
        : setisSmallviewWidth(false);
    });
  }, []);

  useEffect(() => {
    const chartDom = document.querySelector("#budgetChart");
    const budgetChart = echarts.init(chartDom);

    const option = {
      legend: {
        top: "top", // Position the legend at the top
        left: "center",
        textStyle: {
          color: "#f3f3f3", // Change this to your desired color
          fontSize: 12, // Optional: change the font size
        },
        data: ["Allocated Budget", "Actual Spending"],
      },
      radar: {
        // Adjust the radius and center of the radar to avoid overlapping
        center: ["55%", smallViewWidth ? "60%" : "62%"],
        radius: "55%",
        indicator: [
          { name: "Sales", max: 6500 },
          { name: "Administration", max: 16000 },
          { name: "Information Technology", max: 30000 },
          { name: "Customer Support", max: 38000 },
          { name: "Development", max: 52000 },
          { name: "Marketing", max: 25000 },
        ],
        name: {
          textStyle: {
            fontSize: 12, // Adjust font size if necessary
            overflow: "truncate", // Ensure long names are truncated instead of overflowing
          },
        },
      },
      series: [
        {
          name: "Budget vs spending",
          type: "radar",
          data: [
            {
              value: [4200, 3000, 20000, 35000, 50000, 18000],
              name: "Allocated Budget",
            },
            {
              value: [5000, 14000, 28000, 26000, 42000, 21000],
              name: "Actual Spending",
            },
          ],
        },
      ],
    };

    budgetChart.setOption(option);

    // Cleanup function to destroy the chart on component unmount
    return () => {
      budgetChart.dispose();
    };
  }, [smallViewWidth]);

  return <div id="budgetChart" className="budgetChart"></div>;
}
